import { typeToKey, unitsTypes } from '../constants/dashboards';
import { generateUnits } from '../reducers/dashboard/compose';
import { getDashboardName, getSelectedDashboard, getUnits } from '../reducers/analyticsApp';
import { transformFunnelUnit } from '../utils/dashboards';

const removeExtraFields = (units) =>
  units.map((u) => ({ ...u, compose: { [typeToKey[u.type]]: u.compose[typeToKey[u.type]] } }));

const reviveExtraFields = (units) =>
  units.map((u) => ({
    ...u,
    compose: { ...generateUnits(1)[0].compose, [typeToKey[u.type]]: u.compose[typeToKey[u.type]] },
  }));

export const toNewDashboard = (state) => {
  const units = getUnits(state).map((unit) =>
    unit.type === unitsTypes.FUNNELS_TYPE ? transformFunnelUnit(unit) : unit
  );

  return {
    name: getDashboardName(state),
    description: JSON.stringify(removeExtraFields(units)),
  };
};

export const toUpdatedDashboard = (state) => {
  const units = getUnits(state).map((unit) =>
    unit.type === unitsTypes.FUNNELS_TYPE ? transformFunnelUnit(unit) : unit
  );

  return {
    id: getSelectedDashboard(state),
    name: getDashboardName(state),
    description: JSON.stringify(removeExtraFields(units)),
  };
};

export const fromCreateUpdateDashboardResponse = ({ id, name, description }) => ({
  dashboard: { id, name, units: reviveExtraFields(JSON.parse(description)) },
});

export const fromGetDashboardResponse = (response) => ({
  dashboards: (response || []).map(({ id, name, description }) => ({
    id,
    name,
    units: JSON.parse(description || '[]'),
  })),
});
